import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getPalika, getParticularPage, getNext, getPrevious, createPalika, updatePalika, handleSearch } from "./thunk";

const initialState = {
  palikas: [],
  edit: false,
  palika: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingPalika: false,
  loadingNext: false,
  showCreateModal: false,
};

export const palikaSlice = createSlice({
  name: "palika",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    palikaEditSuccess: (state, action) => {
      state.edit = true;
      state.palika = state.palikas.find((palika) => palika.id === action.payload);
    },
    clearAllPalika: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingPalika = false;
      state.palika = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createPalika.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createPalika.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createPalika.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updatePalika.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updatePalika.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updatePalika.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(getPalika.pending, getParticularPage.pending, getPrevious.pending, getNext.pending, handleSearch.pending),
      (state) => {
        state.loadingPalika = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getPalika.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingPalika = false;
        state.palikas = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getPalika.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingPalika = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, palikaEditSuccess, clearAllPalika } = palikaSlice.actions;

export default palikaSlice.reducer;
